import i18next from "i18next";

import EditorOption from "./EditorOption";
import ImageOption from "./ImageOption";
import InputOption from "./InputOption";
import MultiInputOption from "./MultiInputOption";

export const DEFAULT_OPTION_LABEL = i18next.t(
  "neetoMolecules.optionFields.defaultOption"
);

export const IMAGE_UPLOAD_CONFIG = {
  maxImageSize: 1,
  allowedImageTypes: {
    "image/jpg": [".jpg", ".jpeg"],
    "image/png": [".png"],
    "image/svg": [".svg"],
  },
};

export const INPUT_TYPES = { TEXT: "text", NUMBER: "number" };

export const OPTION_ACTIONS = {
  UPDATE_IMAGE: "update_image",
  UPDATE_VALUES: "update_values",
  UPDATE_LABEL: "update_label",
  DELETE: "delete",
  REORDER: "reorder",
  ADD: "add",
  BULK_ADD: "bulk_add",
  CLONE: "clone",
};

export const OPTION_MAP = {
  multiInput: MultiInputOption,
  pictureChoice: ImageOption,
  editor: EditorOption,
  input: InputOption,
};
